import { matchPath } from 'react-router-dom';

import { APP_ROUTES } from 'routes/routePaths';

export enum MainPageView {
  MEETINGS = 'meetings',
  CALENDAR = 'calendar',
  MESSENGER = 'messenger',
}

export const getViewFromPath = (pathname: string, isMessengerEnabled: boolean): MainPageView => {
  switch (pathname) {
    case APP_ROUTES.calendar:
      return MainPageView.CALENDAR;
    case APP_ROUTES.meetings:
      return MainPageView.MEETINGS;
    case APP_ROUTES.messenger:
      return isMessengerEnabled ? MainPageView.MESSENGER : MainPageView.MEETINGS;
    default:
      if (matchPath(APP_ROUTES.meetingDetail, pathname)) return MainPageView.MEETINGS;
      if (isMessengerEnabled && matchPath('/messenger/:roomId', pathname)) return MainPageView.MESSENGER;

      return isMessengerEnabled ? MainPageView.MESSENGER : MainPageView.MEETINGS;
  }
};

export const getPathForView = (view: MainPageView, isMessengerEnabled: boolean) => {
  if (!isMessengerEnabled && view === MainPageView.MESSENGER) return;

  switch (view) {
    case MainPageView.CALENDAR:
      return '/calendar';
    case MainPageView.MEETINGS:
      return APP_ROUTES.meetings;
    case MainPageView.MESSENGER:
      return '/messenger';
    default:
      return;
  }
};
